import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { Editor } from '@tinymce/tinymce-react';
import {
  useGetStandardLetterParameterQuery,
  useUpdateCompanyLetterTemplateMutation,
  useUpdateLetterTemplateMutation,
} from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import AppContext from 'containers/App/Store/AppContext';
import { useEDocTemplate } from './DocTemplate';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';

export const LetterDesignForm = (props: any) => {
  const {
    pageMode,
    standardLetterID,
    letterTemplateID,
    companyID,
    companyLetterTemplateID,
  }: any = useParams();
  const isHomeDefault = localStorage.getItem('isDefault');
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const { globalState, dispatch }: any = useContext(AppContext as any);
  let history = useHistory();
  let location: any = useLocation();
  const pathParts = location.pathname.split('/');
  const mode = pathParts.includes('general-settings')
    ? 'general-settings'
    : pathParts.includes('company-setup')
    ? 'company-setup'
    : '';
  let editData = location.state;
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );

  const { htmlWrapper } = useEDocTemplate();

  const {
    loading,
    data: { getStandardLetterParameter } = { getStandardLetterParameter: [] },
  } = useGetStandardLetterParameterQuery({
    variables: {
      standardLetterID: standardLetterID,
    },
    fetchPolicy: 'network-only',
  });
  const [
    //updateLetterTemplate to updateLetterTemplate
    updateLetterTemplate,
    { loading: updateLetterTemplateLoading, error: updateLetterTemplateError },
  ] = useUpdateLetterTemplateMutation({
    onError: error => {
      setSnackBarMsg(error.message);
    },
    onCompleted: ({ updateLetterTemplate }) => {
      if (updateLetterTemplate) {
        setOpenSnackBar(true);
        setSnackBarMsg(SystemMsgs.updateRecord());
        history.push({
          pathname:
            mode === 'general-settings'
              ? `/${pageMode}/general-settings/standard-letter/${standardLetterID}/letter-template`
              : mode === 'company-setup' && !pageMode
              ? `/company-setup/submenu/${companyID}/standard-letter/${standardLetterID}/letter-template`
              : `/company-setup/submenu/${companyID}/${pageMode}/standard-letter/${standardLetterID}/letter-template`,
        });
      } else {
        setSnackBarMsg('Update Failed!');
      }
    },
  });
  const [
    //updateCompanyLetterTemplate to updateCompanyLetterTemplate
    updateCompanyLetterTemplate,
    {
      loading: updateCompanyLetterTemplateLoading,
      error: updateCompanyLetterTemplateError,
    },
  ] = useUpdateCompanyLetterTemplateMutation({
    onError: error => {
      setSnackBarMsg(error.message);
    },
    onCompleted: ({ updateCompanyLetterTemplate }) => {
      if (updateLetterTemplate) {
        setOpenSnackBar(true);
        setSnackBarMsg(SystemMsgs.updateRecord());
        history.push({
          pathname:
            mode === 'general-settings'
              ? `/${pageMode}/general-settings/standard-letter/${standardLetterID}/letter-template`
              : mode === 'company-setup' && !pageMode
              ? `/company-setup/submenu/${companyID}/standard-letter/${standardLetterID}/letter-template`
              : `/company-setup/submenu/${companyID}/${pageMode}/standard-letter/${standardLetterID}/letter-template`,
        });
      } else {
        setSnackBarMsg('Update Failed!');
      }
    },
  });

  const [contentValue, setContentValue] = useState('');
  const [ConfirmationDialog, setConfirmationDialog] = useState(false);
  const [IsChange, setIsChange] = useState(false);
  const checkIsChange = (changed: boolean) => {
    if (!changed) {
      return history.goBack();
    } else {
      return setConfirmationDialog(true);
    }
  };

  useEffect(() => {
    if (!!editData) {
      setContentValue(editData?.templateBody);
    }
  }, [editData, document]);

  const newContentValue = contentValue?.replaceAll('&nbsp;', '');

  const onSubmit = () => {
    if (companyID) {
      updateCompanyLetterTemplate({
        variables: {
          input: {
            ID: companyLetterTemplateID,
            templateBody: newContentValue,
          },
        },
      });
    } else {
      updateLetterTemplate({
        variables: {
          input: {
            ID: letterTemplateID,
            templateBody: newContentValue,
          },
        },
      });
    }
  };

  const itemName = getStandardLetterParameter
    ?.map(x => {
      if (x?.columnName === '[DateTime]') return '[Date/Time]';
      return x?.columnName;
    })
    ?.join(' ');

  const newListing = getStandardLetterParameter;

  let headerTitle: string = '';
  switch (pageMode) {
    case 'client-account':
      headerTitle = smallTitle.CLIENT_ACCOUNTS;
      break;
    case 'subcontractor':
      headerTitle = smallTitle.SUBCON_ACCOUNTS;
      break;
    case 'subcontract':
      headerTitle = smallTitle.SUB_CONTRACT_MANAGEMENT;
      break;
    case 'supplier':
      headerTitle = smallTitle.SUPPLIER_ACCOUNTS;
      break;
    case 'client-contract':
      headerTitle = smallTitle.PROJECT_PURCHASES;
      break;
    default:
      headerTitle = smallTitle.PRODUCT;
      break;
  }

  return (
    <>
      {loading && <Loading />}
      {updateLetterTemplateLoading && <Loading />}
      {updateCompanyLetterTemplateLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname:
              mode === 'general-settings'
                ? `/${pageMode}/general-settings/standard-letter/${standardLetterID}/letter-template`
                : mode === 'company-setup' && !pageMode
                ? `/company-setup/submenu/${companyID}/standard-letter/${standardLetterID}/letter-template`
                : `/company-setup/submenu/${companyID}/${pageMode}/standard-letter/${standardLetterID}/letter-template`,
          });
        }}
        smTitle={isHomeDefault === 'true' ? 'ContractX' : headerTitle}
        title={user?.companyName}
        routeSegments={
          globalState?.isPathSysAdmin
            ? [
                { name: 'System Admin' },
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
            : [
                { name: 'System Admin' },
                { name: 'Document Template' },
                { name: 'Letter Template', current: true },
              ]
        }
        rightRouteSegments={[
          {
            name: 'Design',
            current: true,
          },
        ]}
      />

      <DynamicSubHeader title={editData?.Name ?? editData?.name} />

      <ContentWrapper search>
        {!loading ? (
          <Editor
            apiKey={'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat'}
            init={{
              convert_urls: false,
              plugins:
                'preview paste importcss searchreplace autolink autosave  directionality code visualblocks visualchars fullscreen image link  template table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
              imagetools_cors_hosts: ['picsum.photos'],
              menubar: 'file edit view insert format tools table custom ',
              toolbar:
                ' customInsertButton | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview   | insertfile image  template link anchor code | ltr rtl',
              toolbar_sticky: true,
              image_advtab: true,
              //importcss_append: true,
              entity_encoding: 'raw',
              forced_root_block: false,

              menu: {
                custom: {
                  title: 'Parameters',
                  items: itemName,
                },
              },
              setup: function(editor) {
                editor.ui.registry.addButton('customInsertButton', {
                  text: 'Reset',
                  onAction: function(_) {
                    setContentValue(editData?.templateBody);
                    setIsChange(true);
                    // editor.insertContent(
                    //   "&nbsp;<strong>It's my button!</strong>&nbsp;"
                    // )
                  },
                });
                return newListing?.map(x => {
                  const slicedColumnName = x?.columnName
                    ?.replaceAll('[', '')
                    ?.replaceAll(']', '')
                    ?.trim();

                  const newParams =
                    x?.columnName === '[Date/Time]'
                      ? '[DateTime]'
                      : x?.columnName;
                  editor.ui.registry?.addMenuItem(x.columnName, {
                    text: `${slicedColumnName}`,
                    onAction: function() {
                      editor.insertContent(`${newParams}`);
                    },
                  });
                });
              },

              height: 700,
            }}
            value={contentValue}
            onEditorChange={(newValue, editor) => {
              setContentValue(newValue);
              setIsChange(true);
            }}
          />
        ) : null}

        <Footer
          options={[
            {
              name: 'Save',
              onClick: () => onSubmit(),

              color: 'primary',
            },
          ]}
        />
      </ContentWrapper>
    </>
  );
};
